import { VehiclesTypes } from '@/features/Vehicles/types';

export const COLUMN_WIDTHS: Record<string, string> = {
  SELECT: '3rem',
  TAG: 'minmax(0, 1fr)',
  VIN: 'minmax(0, 1fr)',
  VEHICLE_NO: 'minmax(0, 1fr)',
  AIRPORT: 'minmax(0, 1fr)',
  EXCHANGE_PLACE: 'minmax(0, 1fr)',
  PHONE: 'minmax(0, 1fr)',
  STATUS: 'minmax(0, 1fr)',
};

export type VehicleColumnKey = keyof typeof COLUMN_WIDTHS;

export const ALL_COLUMNS: VehicleColumnKey[] = ['SELECT', 'TAG', 'VIN', 'VEHICLE_NO', 'AIRPORT', 'EXCHANGE_PLACE', 'PHONE', 'STATUS'];

export const getVisibleColumns = (settings: VehiclesTypes.Settings): VehicleColumnKey[] =>
  [
    settings.columns.SELECT && 'SELECT',
    settings.columns.TAG && 'TAG',
    settings.columns.VIN && 'VIN',
    settings.columns.VEHICLE_NO && 'VEHICLE_NO',
    settings.columns.AIRPORT && 'AIRPORT',
    settings.columns.EXCHANGE_PLACE && 'EXCHANGE_PLACE',
    settings.columns.PHONE && 'PHONE',
    settings.columns.STATUS && 'STATUS',
  ].filter(Boolean) as VehicleColumnKey[];

export const getVehicleTableGridTemplateColumns = (settings: VehiclesTypes.Settings): string =>
  getVisibleColumns(settings)
    .map((col) => COLUMN_WIDTHS[col])
    .join(' ');
